import React from 'react'

const AussieRules = ({ width = '24px', height = '25px', fill = '#fff' }) => {
  return (
    <svg style={{ width, height, fill }} viewBox='0 0 24 25' version='1.1'>
      <title>aussie rules</title>
      <g id='Pre-Reg-Landing-Page' stroke='none' strokeWidth='1' fillRule='evenodd'>
        <g id='Desktop-10-Copy' transform='translate(-620.000000, -629.000000)' fillRule='nonzero'>
          <g id='onboarding/sport-copy-18' transform='translate(579.000000, 605.000000)'>
            <g id='icon/16/sport/rugby/rugby-ball' transform='translate(41.000000, 24.089286)'>
              <path
                d='M23.7951116,3.54322256 L22.6851116,3.70822256 L23.7951116,3.54322256 C23.5311207,1.81973034 22.1747728,0.469464804 20.4501116,0.213222562 C14.8510175,-0.664508973 9.17093332,1.1990943 5.18011156,5.22322256 C1.18337127,9.18607723 -0.664108944,14.8289851 0.215111564,20.3882226 L0.215111564,20.3882226 C0.486221326,22.0941706 1.83563298,23.425347 3.54511156,23.6732226 C4.46075985,23.8511731 5.38826663,23.9614712 6.32011156,24.0032246 C11.0202487,24.0055021 15.5255784,22.1255803 18.8301116,18.7832226 C22.8546289,14.8065108 24.7047998,9.12743636 23.7951116,3.54322256 Z M6.77011156,6.81322256 C10.019638,3.52663057 14.5741792,1.87443909 19.1751116,2.31322256 C12.4866084,6.74941033 6.76648918,12.495043 2.36011156,19.2032226 C1.88077354,14.618828 3.50205513,10.0637988 6.77011156,6.81322256 L6.77011156,6.81322256 Z M17.2701116,17.1182226 C13.7822177,20.6374012 8.81331355,22.2620654 3.92011156,21.4832226 L3.65011156,21.4082226 C8.19442005,14.2014533 14.2933423,8.10253105 21.5001116,3.55822256 C21.5440104,3.66519031 21.5791265,3.77555497 21.6051116,3.88822256 C22.3638047,8.74368843 20.7392634,13.6675559 17.2401116,17.1182226 L17.2701116,17.1182226 Z'
                id='path'
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default AussieRules
